"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _bootstrap = require("./bootstrap");
var _validators = require("./validators");
var _autoform = require("./autoform");
var _informed = require("informed");
var _excluded = ["field"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FIELD_MAPPINGS = {
  string: _bootstrap.BootstrapText,
  choice: _bootstrap.BootstrapChoiceSelect,
  "boolean": _bootstrap.BootstrapCheckbox
};
var AutoFieldWrapper = /*#__PURE__*/function (_Component) {
  function AutoFieldWrapper(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AutoFieldWrapper);
    _this = _callSuper(this, AutoFieldWrapper, [props]);
    _this.fieldSchema = null;
    return _this;
  }
  (0, _inherits2["default"])(AutoFieldWrapper, _Component);
  return (0, _createClass2["default"])(AutoFieldWrapper, [{
    key: "getSchema",
    value: function getSchema(schema) {
      if (this.fieldSchema != null) {
        return this.fieldSchema;
      }
      var fullField = this.props.formApi.getFullField(this.props.field);
      var parts = fullField.split(".");
      this.fieldSchema = schema;
      for (var index in parts) {
        var part = parts[index].replace(/\[.*]$/, "");
        this.fieldSchema = this.fieldSchema[part];
        if (this.fieldSchema === undefined) {
          return {};
        }
        if (this.fieldSchema.type === "field") {
          this.fieldSchema = this.fieldSchema.child.children;
        }
      }
      return this.fieldSchema;
    }
  }, {
    key: "getLabel",
    value: function getLabel(schema) {
      return this.getSchema(schema).label;
    }
  }, {
    key: "getType",
    value: function getType(schema) {
      return this.getSchema(schema).type;
    }
  }, {
    key: "getRequired",
    value: function getRequired(schema) {
      return this.getSchema(schema).required;
    }
  }, {
    key: "getReadOnly",
    value: function getReadOnly(schema) {
      return this.getSchema(schema).read_only;
    }
  }, {
    key: "getMaxLength",
    value: function getMaxLength(schema) {
      return this.getSchema(schema).max_length;
    }
  }, {
    key: "getChoices",
    value: function getChoices(schema) {
      return this.getSchema(schema).choices;
    }
  }, {
    key: "getValidators",
    value: function getValidators(schema) {
      var validators = [];
      if (this.getRequired(schema)) {
        validators.push(_validators.isRequired);
      }
      var max_length = this.getMaxLength(schema);
      if (max_length) {
        validators.push((0, _validators.maxLength)(max_length));
      }
      return validators;
    }
  }, {
    key: "getValidatorFunc",
    value: function getValidatorFunc(schema) {
      var validators = this.getValidators(schema);
      return function (value) {
        for (var index in validators) {
          var validator = validators[index];
          var result = validator(value);
          if (!result.valid) {
            return {
              error: result.message
            };
          }
        }
      };
    }
  }, {
    key: "renderField",
    value: function renderField(schema) {
      var _this$props = this.props,
        field = _this$props.field,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var newProps = {
        field: field,
        label: this.getLabel(schema),
        validate: this.getValidatorFunc(schema),
        maxlength: this.getMaxLength(schema),
        choices: this.getChoices(schema)
      };
      var Field = FIELD_MAPPINGS[this.getType(schema)] || _bootstrap.BootstrapText;
      return /*#__PURE__*/_react["default"].createElement(Field, (0, _extends2["default"])({}, newProps, rest));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement(_autoform.AutoFormContext.Consumer, null, function (schema) {
        return _this2.renderField(schema);
      });
    }
  }]);
}(_react.Component);
var AutoField = (0, _informed.asField)((0, _informed.withFormApi)(AutoFieldWrapper));
var _default = exports["default"] = AutoField;